// import React from 'react';
// import Box from '@mui/material/Box';
// import Toolbar from '@mui/material/Toolbar';
// import { createTheme, ThemeProvider } from '@mui/material/styles';

// import Container from '@mui/material/Container';
// import DashTheme from './DashTheme';
// import GalleryAdd from './GalleryAdd';



// // export default function Gallery() {
// //     const [open, setOpen] = React.useState(true);
// //     const toggleDrawer = () => {
// //         setOpen(!open);
// //     };


// //     // TODO remove, this demo shouldn't need to reset the theme.
// //     const defaultTheme = createTheme();

// //     return (
// //         <ThemeProvider theme={defaultTheme}>
// //             <Box sx={{ display: 'flex' }}>
// //                 <DashTheme />
// //                 <Box
// //                     component="main"
// //                     sx={{
// //                         backgroundColor: (theme) =>
// //                             theme.palette.mode === 'light'
// //                                 ? theme.palette.grey[100]
// //                                 : theme.palette.grey[900],
// //                         flexGrow: 1,
// //                         height: '100vh',
// //                         overflow: 'auto',
// //                     }}
// //                 >
// //                     <Toolbar />
// //                     <Container maxWidth="lg" sx={{ mt: 4, mb: 2 }}>

// //                         <GalleryAdd />


// //                     </Container>
// //                 </Box>
// //             </Box>
// //         </ThemeProvider>
// //     );
// // }


// export default function Gallery() {
//   return (
//     <Box sx={{ display: 'flex' }}>
//       <DashTheme />
//       <Box
//         component="main"
//         sx={{
//           backgroundColor: (theme) =>
//             theme.palette.mode === 'light'
//               ? theme.palette.grey[100]
//               : theme.palette.grey[900],
//           flexGrow: 1,
//           minHeight: '100vh', // ✅ fixed
//           overflow: 'auto',
//         }}
//       >
//         <Toolbar />
//         <Container maxWidth="lg" sx={{ mt: 4, mb: 2 }}>
//           <GalleryAdd />
//         </Container>
//       </Box>
//     </Box>
//   );
// }



import React from 'react'; // 🎨 IMPROVEMENT: stable layout component
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Container from '@mui/material/Container';
import GalleryAdd from './GalleryAdd';
import DashTheme from './DashTheme';

export default function Gallery() {
  return (
    <Box sx={{ display: 'flex' }}>
      <DashTheme />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minHeight: '100vh', // ❗ IMPORTANT: maintain full height
          overflowY: 'auto', // FIX: ResizeObserver issue - use auto to prevent flickering
          backgroundColor: (theme) => theme.palette.grey[50]
        }}
      >
        <Toolbar />
        {/* ✅ UI FIX: Added padding to container to prevent edge collisions */}
        <Container maxWidth="lg" sx={{ py: 4 }}>
          <GalleryAdd />
        </Container>
      </Box>
    </Box>
  );
}